import { render, staticRenderFns } from "./MarketplaceProductsModule.vue?vue&type=template&id=7119d801&scoped=true"
import script from "./MarketplaceProductsModule.vue?vue&type=script&lang=js"
export * from "./MarketplaceProductsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7119d801",
  null
  
)

export default component.exports